import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=b5e6c2a4&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=ts"
export * from "./ChatDialog.vue?vue&type=script&lang=ts"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=b5e6c2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e6c2a4",
  null
  
)

export default component.exports